
import { useEffect, useState } from 'react';
import { getContactInfo, sendContactMessage } from '../../../api/apiServices';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('idle');
  const [contact, setContact] = useState([])
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      const fetchContact = async () => {
        try {
          const res = await getContactInfo();
  
          if (res?.data) {
            setContact(res.data);
          }
        } catch (error) {
          console.error("Fetch Contact Error:", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchContact();
    }, []);

  const handleSubmit = async (e) => {
  e.preventDefault();
  

  try {
    setIsSubmitting(true);
    setSubmitStatus('idle')

    await sendContactMessage({
      name: formData.name,
      email: formData.email,
      subject: formData.subject,
      message: formData.message,
    });

    setSubmitStatus("success");
    setFormData({
      name: "",
      email: "",
      subject: "",
      message: "",
    });
  } catch (error) {
    console.error(error);
    setSubmitStatus("error");
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <section id="contact" className="py-16 sm:py-24 px-4 sm:px-6 lg:px-20 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-12 lg:gap-16">
          {/* Left - Contact Info */}
          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#6a4bc3] mb-4 sm:mb-6">
              {contact?.title}
            </h2>
            <p className="text-gray-700 text-sm sm:text-base lg:text-lg leading-relaxed mb-8 sm:mb-12">
              {contact?.description}
            </p>

            <div className="space-y-6 sm:space-y-8">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#6a4bc3]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-lg sm:text-xl text-[#6a4bc3]"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">Email Us</h3>
                  <p className="text-gray-600 text-sm sm:text-base">{contact?.email}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#6a4bc3]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-lg sm:text-xl text-[#6a4bc3]"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">Call Us</h3>
                  <p className="text-gray-600 text-sm sm:text-base">{contact?.phone}</p>
                  <p className="text-xs sm:text-sm text-gray-500">{contact?.hotlineNote}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#6a4bc3]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-lg sm:text-xl text-[#6a4bc3]"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">Visit Us</h3>
                  <p className="text-gray-600 text-sm sm:text-base">{contact?.address}</p>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="mt-8 sm:mt-12">
              <h3 className="font-semibold text-gray-900 mb-4 text-sm sm:text-base">Follow Our Journey</h3>
              <div className="flex gap-3 sm:gap-4">
                <a href={contact?.facebook} className="w-10 h-10 sm:w-12 sm:h-12 bg-[#6a4bc3] rounded-full flex items-center justify-center text-white hover:bg-[#c9a24d] transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg sm:text-xl"></i>
                </a>
                <a href={contact?.twitter} className="w-10 h-10 sm:w-12 sm:h-12 bg-[#6a4bc3] rounded-full flex items-center justify-center text-white hover:bg-[#c9a24d] transition-colors cursor-pointer">
                  <i className="ri-twitter-x-fill text-lg sm:text-xl"></i>
                </a>
                <a href={contact?.instagram} className="w-10 h-10 sm:w-12 sm:h-12 bg-[#6a4bc3] rounded-full flex items-center justify-center text-white hover:bg-[#c9a24d] transition-colors cursor-pointer">
                  <i className="ri-instagram-fill text-lg sm:text-xl"></i>
                </a>
                <a href={contact?.linkedin} className="w-10 h-10 sm:w-12 sm:h-12 bg-[#6a4bc3] rounded-full flex items-center justify-center text-white hover:bg-[#c9a24d] transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-lg sm:text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Right - Contact Form */}
          <div className="bg-gradient-to-br from-[#f8f6fc] to-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-lg">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">Send Us a Message</h3>
            
            <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Your Name *
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6a4bc3] text-sm"
                  placeholder="Enter your name"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Email Address *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6a4bc3] text-sm"
                  placeholder="your.email@example.com"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Subject *
                </label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6a4bc3] text-sm"
                  placeholder="What is this regarding?"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Message *
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={(e) => {
                    if (e.target.value.length <= 500) {
                      setFormData({ ...formData, message: e.target.value });
                    }
                  }}
                  required
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6a4bc3] text-sm resize-none"
                  placeholder="Tell us how we can help..."
                />
                <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500 characters</p>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-sm">
                  Thank you for reaching out! We'll get back to you soon.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">
                  Something went wrong. Please try again.
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#6a4bc3] text-white py-3 sm:py-4 rounded-full font-semibold hover:bg-[#5a3ba3] transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
